<script>

import StepperRecyclingCreateFolder
  from '@/views/restricted/recyclingModule/acquisition/StepperRecyclingCreateFolder.vue'
import RepairFileService from '@/services/RepairFileService'
import RecyclingFolderStatusConstant from '@/constants/recyclingModule/RecyclingFolderStatusConstant'
import StepProductInformation from '@/components/recycling-module/acquisition/stepper/StepProductInformation.vue'
import StepProductChecking from '@/components/recycling-module/acquisition/stepper/StepProductChecking.vue'
import StepProductPackaging from '@/components/recycling-module/acquisition/stepper/StepProductPackaging.vue'
import RecyclingFolderService from '@/services/recyclingModule/RecyclingFolderService'

export default {
  name: 'RecyclingCreateFolderPage',
  components: {
    StepProductPackaging,
    StepProductChecking,
    StepProductInformation,
    StepperRecyclingCreateFolder
  },
  props: {
    recyclingFolderBoomerangId: String
  },
  data() {
    return {
      currentStep: 0,
      highestStepReached: 0,
      dataLoaded: false,

      repairFileBoomerangId: null,
      currentRepairFile: null,

      currentRecyclingFolder: null,

      step: null,
    }
  },
  watch: {
    async recyclingFolderBoomerangId() {
      this.currentRecyclingFolder = await RecyclingFolderService.getRecyclingFolder(
        this.recyclingFolderBoomerangId)
      await this.getActualPosition()
    },
    async currentStep() {
      this.dataLoaded = false
      if (this.recyclingFolderBoomerangId) {
        this.currentRecyclingFolder = await RecyclingFolderService.getRecyclingFolder(
          this.recyclingFolderBoomerangId)
      }
      this.dataLoaded = true

      if (this.currentRecyclingFolder && this.currentRecyclingFolder.step !== this.step
        && this.currentRecyclingFolder.status !== this.status) {
        await this.getActualPosition()
        this.step = this.getActualPosition.step
        this.status = this.currentRecyclingFolder.status
      }
    }
  },
  async created() {
    if (this.$route.query.repairFileBoomerangId) {
      this.repairFileBoomerangId = this.$route.query.repairFileBoomerangId
      this.currentRepairFile = await RepairFileService.get(this.repairFileBoomerangId)
    }

    if (this.$route.params.recyclingFolderBoomerangId) {
      this.currentRecyclingFolder = await RecyclingFolderService.getRecyclingFolder(
        this.recyclingFolderBoomerangId)

      await this.getActualPosition()
    } else {
      this.currentStep = 1
    }
  },
  methods: {
    async handleStepChange(changeStep) {
      if (changeStep !== this.currentStep) {
        if (this.currentRecyclingFolder) {
          if (this.currentRecyclingFolder.status !== RecyclingFolderStatusConstant.PRODUCT_CHECKED
            && this.currentStep === 3
            && changeStep < this.currentStep) {
            await this.$refs.stepProductPackaging.updatePartial()
          }
        }
        this.currentStep = changeStep
      }
    },
    handleHighestStepChange(highestStepReached) {
      this.highestStepReached = highestStepReached
    },
    async getActualPosition() {
      switch (this.currentRecyclingFolder.status) {
        case RecyclingFolderStatusConstant.PRODUCT_INFORMATION_SAVED:
          await this.handleStepChange(2)
          this.handleHighestStepChange(2)
          break
        case RecyclingFolderStatusConstant.PRODUCT_CHECKED:
          await this.handleStepChange(3)
          this.handleHighestStepChange(3)
          break
        default:
          await this.$router.push({ name: 'RecyclingPage' })
          break
      }
    },
    async handleRefreshRecyclingFolder() {
      this.currentRecyclingFolder = await RecyclingFolderService.getRecyclingFolder(
        this.recyclingFolderBoomerangId)
    }
  }
}
</script>

<template>
  <v-row class="h-100" no-gutters>
    <v-col cols="12">
      <v-container fluid>
        <StepperRecyclingCreateFolder
          @change-step="handleStepChange"
          @change-highest-step="handleHighestStepChange"
          :currentStep="currentStep"
          :highestStepReached="highestStepReached"
          :currentRecyclingFolder="currentRecyclingFolder"
        />

        <StepProductInformation
          ref="StepProductInformation"
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRepairFile="currentRepairFile"
          :currentRecyclingFolder="currentRecyclingFolder"
          v-if="currentStep === 1 && dataLoaded"
        />
        <StepProductChecking
          ref="StepProductChecking"
          @change-step="handleStepChange"
          @refresh-recycling-folder="handleRefreshRecyclingFolder"
          :currentStep="currentStep"
          :currentRecyclingFolder="currentRecyclingFolder"
          v-if="currentRecyclingFolder
           && currentStep === 2
           && dataLoaded"
        />
        <StepProductPackaging
          ref="StepProductPackaging"
          @change-step="handleStepChange"
          :currentStep="currentStep"
          :currentRecyclingFolder="currentRecyclingFolder"
          v-if="currentRecyclingFolder
           && currentStep === 3
           && dataLoaded"
        />
      </v-container>
    </v-col>
  </v-row>
</template>

<style scoped>
v-container {
  height: 100%;
}

img {
  width: 30%;
  margin-bottom: 44px;
}
</style>
